export const omProjectConstants = {
    GET_SUCCESS: 'GET_OMPROJECT_SUCCESS',

    ADD_SUCCESS: 'ADD_OMPROJECT_SUCCESS',
    ADD_FAILURE: 'ADD_OMPROJECT_FAILURE',

    DELETE_SUCCESS: 'DELETE_OMPROJECT_SUCCESS',
    DELETE_FAILURE: 'DELETE_OMPROJECT_FAILURE',

    UPDATE_SUCCESS: 'UPDATE_OMPROJECT_SUCCESS',
    UPDATE_FAILURE: 'UPDATE_OMPROJECT_FAILURE',

    CLEAR_ERROR: 'CLEAR_OMPROJECT_ERROR_CODE'
};
